import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/css';

export default Tooltip;
